export const RECEIVED_BANNER = 'RECEIVED_BANNER';

const getMessageBanner = (reference, type, title, body, closeable) => (
    (dispatch) => {
        dispatch({
            type: RECEIVED_BANNER,
            messageBanner: {
                reference,
                type,
                title,
                body,
                closeable,
            },
        });
    }
);

export default getMessageBanner;
